import { Injectable } from '@angular/core';
import { observable } from 'mobx-angular';
import { action } from 'mobx';
import { Guides } from '../mocks/guides.mock';
import { ShoppingList, ShoppingListItem } from '../models/shopping-list.model';


@Injectable()
export class ShoppingListStore {
    @observable shoppingListsGroups: ShoppingList[] = [];

    constructor() {
    }

    @action
    setShoppingListGruops(shoppingListGroups, parse: boolean) {
        const shoppingListsGroups: ShoppingList[] = [];
        if (parse) {
            shoppingListGroups.forEach(item => {
                const shoppingList = this.shoppingListParse(item);
                shoppingListsGroups.push(shoppingList);
            });
        }
        this.shoppingListsGroups = [...[], ...shoppingListsGroups];
        console.log(shoppingListsGroups);
    }

    shoppingListParse(shoppingListSrc): ShoppingList {
        const shoppingList: ShoppingList = {
            title: shoppingListSrc.name,
            items: []
        };
        const content = shoppingListSrc.content.replace(/<\/li>/gm, ',').replace(/<ul>|<\/ul>|<li>|\\n|<br>|&nbsp;/gmi, '');
        const items = content.split(',');
        items.forEach( item => {
            if (item === undefined || item === null || item === '\n' || item === '↵' || item === '') { return; }
            const shoppingListItem: ShoppingListItem = {
                ingredient: item
            };
            shoppingList.items.push(shoppingListItem);
        });
        return shoppingList;
    }

    resetListsItemsSelections() {
        this.shoppingListsGroups.forEach( group => {
            group.items.forEach(item => {
                item.isChecked = false;
            });
        });
    }
}